import { API } from '../../api';
import { Collapse, Input, PageHeader, Row, Spin, notification } from 'antd';
import { DimaContext } from '../../DimaContext';
import { Link, useParams, useRouteMatch } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';

const { Panel } = Collapse;
const { TextArea } = Input;

const ActionDetail = () => {
  const context = useContext(DimaContext);
  const { actionId } = useParams();
  const [action, setAction] = useState({});
  const [loading, setLoading] = useState(false);
  const { url } = useRouteMatch();

  const actionStatusToColorMap = {
    Failed: {
      color: '#cf1322',
      border: '#ffa39e',
      background: '#fff1f0',
    },
    Processing: {
      color: '#d46b08',
      border: '#ffd591',
      background: 'fff7e6',
    },
    Queued: {
      color: '#096dd9',
      border: '#91d5ff',
      background: '#e6f7ff',
    },
    Succeeded: {
      color: '#389e0d',
      border: '#b7eb8f',
      background: '#f6ffed',
    },
    Created: {
      color: '#000000',
      border: '#000000',
      background: '#FFFFFF',
    },
  };

  const fetchActionById = async () => {
    setLoading(true);

    try {
      const { data } = await API.get(`/dis/actions/${actionId}?clientId=${context.client.id}`);
      setAction(data);
    } catch (err) {
      notification.error({
        message: 'Error',
        description: 'Failed to get Action',
        duration: 3,
        placement: 'topLeft',
      });
    }

    setLoading(false);
  };

  const actionTypeLink = actionType => {
    const urlBase = url.slice(0, Math.max(0, url.indexOf('/job')));
    const linkUrl = `${urlBase}/actionType/${actionType}`;
    return (
      <p>
        <span style={{ fontWeight: 'bold' }}>Action Type: </span>
        <Link to={linkUrl} data-cy={`actionType-link-${actionType}`}>
          {actionType}
        </Link>
      </p>
    );
  };

  useEffect(() => {
    fetchActionById();
  }, [actionId]);

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back()}
        title="Action Detail"
      />
      <Row>
        <p>
          <span style={{ fontWeight: 'bold' }}>ID: </span>
          {action?.id}
        </p>
      </Row>
      <Spin spinning={loading}>
        {action?.actionType && <div>{actionTypeLink(action.actionType)}</div>}
        <div style={{ marginBottom: '10px' }}>
          <span style={{ color: 'black', fontWeight: 'bold' }}>Status:</span>
          <span
            style={{
              border: '1px solid',
              borderColor: actionStatusToColorMap[action?.status]?.border,
              padding: '5px 10px',
              marginLeft: '10px',
              backgroundColor: actionStatusToColorMap[action?.status]?.background,
              color: actionStatusToColorMap[action?.status]?.color,
            }}
          >
            {' '}
            {action.status}{' '}
          </span>
        </div>
        <Row>
          {/* Conditional check is to prevent "Invalid Date" from being displayed during loading */}
          <p>
            <span style={{ fontWeight: 'bold' }}>Started at: </span>
            {action.startedAt && new Date(action.startedAt).toString()}
          </p>
        </Row>
        <Row>
          <p>
            <span style={{ fontWeight: 'bold' }}>Completed at: </span>
            {action.finishedAt && new Date(action.finishedAt).toString()}
          </p>
        </Row>
        <Collapse>
          <Panel header="Errors">
            <TextArea
              id="action-errors-textarea"
              data-cy="action-errors-textarea"
              bordered
              autoSize
              value={JSON.stringify(action?.errors, null, 2)}
              style={{ caretColor: 'transparent' }}
            />
          </Panel>
          <Panel header="Output Payload">
            <TextArea
              id="action-output-payload-textarea"
              data-cy="action-output-payload-textarea"
              bordered
              autoSize
              value={JSON.stringify(action?.outputPayload, null, 2)}
              style={{ caretColor: 'transparent' }}
            />
          </Panel>
        </Collapse>
      </Spin>
    </>
  );
};

export default ActionDetail;
